import { render, staticRenderFns } from "./SidoCodeTable.vue?vue&type=template&id=6b197621&scoped=true"
import script from "./SidoCodeTable.vue?vue&type=script&lang=js"
export * from "./SidoCodeTable.vue?vue&type=script&lang=js"
import style0 from "./SidoCodeTable.vue?vue&type=style&index=0&id=6b197621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b197621",
  null
  
)

export default component.exports